import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import notify from 'devextreme/ui/notify';
import { Dipendente } from 'src/app/models/dipendente';
import { MovimentoArticolo } from 'src/app/models/movimento-articolo';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { AllegatiMovService } from '../../../services/allegati-mov.service';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';
import {
  DxButtonComponent,
  DxFileUploaderComponent,
  DxLoadPanelComponent,
  DxPopupComponent,
  DxTextBoxComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-popup-new-allegato-movimenti',
  templateUrl: './popup-new-allegato-movimenti.component.html',
  imports: [
    DxFileUploaderComponent,
    DxButtonComponent,
    DxTextBoxComponent,
    DxValidatorComponent,
    DxiValidationRuleComponent,
    DxPopupComponent,
    DxLoadPanelComponent,
    DatePipe,
  ],
  standalone: true,
})
export class PopupNewAllegatoMovimentiComponent implements OnInit {
  private allS = inject(AllegatiMovService);
  private dipS = inject(DipendentiService);

  @Output() popupNewAllegatoMovimentiEventEmitter = new EventEmitter<boolean>();
  @Input() mov: MovimentoArticolo;
  value: any[] = [];
  nomeAllegato: string = '';
  dipendente: Dipendente;
  loadPanelVisible = false;

  ngOnInit() {
    this.dipS.get(this.mov.idDipendente).subscribe({
      next: (dati) => {
        this.dipendente = dati;
      },
      error: (error) => {
        console.error('Errore caricamento dati dipendente: ' + error);
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento dati dipendente', 'warning');
        }
      },
    });
  }

  getSelectedFiles() {
    return this.value;
  }

  allegaFile(e, files) {
    const result = e.validationGroup.validate();
    if (result.isValid) {
      const formData = new FormData();
      formData.append('file', files[0]);

      this.loadPanelVisible = true;
      this.allS.allega(this.mov.id, this.nomeAllegato, formData).subscribe({
        next: (dati) => {
          this.loadPanelVisible = false;
          console.log('Allegato movimento inserito id: ' + dati);
          notify({
            message: 'Allegato movimento salvato',
            width: 300,
            shading: true,
          });
          this.popupNewAllegatoMovimentiEventEmitter.emit(true);
        },
        error: (error) => {
          this.loadPanelVisible = false;
          console.error('Errore allega file: ' + error);
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore allega file', 'warning');
          }
        },
      });
    }
  }

  onEsciClick() {
    this.popupNewAllegatoMovimentiEventEmitter.emit(false);
  }
}
